import { IronLogicConverterModeEnum } from '@zaoblako/shared/modules/pacs/enums/iron-logic-converter-mode.enum';
import type { IronLogicCommandQueueFindInterface } from '@zaoblako/shared/modules/pacs/dtos/iron-logic/iron-logic-command-queue-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';

import * as yup from 'yup';

/** "Iron Logic" converter settings response body */
export interface ConverterIconLogicFindInterface {
  /** Device model */
  model?: string;
  /** Device serial number */
  serialNumber?: string;
  /** Device firmware version */
  converterFirmwareVersion?: string;
  /** Device connection module firmware version */
  connectionModuleFirmwareVersion?: string;
  /** Is device active */
  active?: boolean;
  /** Current device mode */
  mode?: IronLogicConverterModeEnum;
  /** Last device mode */
  lastMode?: IronLogicConverterModeEnum;
  /** Last `set_mode` command ID */
  setModeCommand?: IronLogicCommandQueueFindInterface;
  /** Device IP-address */
  ipAddress?: string;
  /** Opening time, sec */
  openTime?: number;
  /** Opening control time, sec */
  openControlTime?: number;
  /** Closing control time, sec */
  closeControlTime?: number;
}

/** "Iron Logic" converter settings response body - DTO schema */
export const ConverterIconLogicFindDto = SerdeDtoClass.create<ConverterIconLogicFindInterface>(PacsDtoKeysEnum.CONVERTER_ICON_LOGIC_FIND_DTO, {
  model: {
    optional: true,
    label: 'Модель',
    serializer: yup.string(),
  },
  serialNumber: {
    optional: true,
    label: 'Серийный номер',
    serializer: yup.string(),
  },
  converterFirmwareVersion: {
    optional: true,
    label: 'Версия прошивки конвертера',
    serializer: yup.string(),
  },
  connectionModuleFirmwareVersion: {
    optional: true,
    label: 'Версия прошивки модуля связи',
    serializer: yup.string(),
  },
  active: {
    optional: true,
    label: 'Активен',
    serializer: yup.boolean(),
  },
  mode: {
    optional: true,
    label: 'Режим работы',
    serializer: yup
      .string()
      .oneOf(Object.values(IronLogicConverterModeEnum)),
  },
  lastMode: {
    optional: true,
    label: 'Предыдущий режим работы',
    serializer: yup
      .string()
      .oneOf(Object.values(IronLogicConverterModeEnum)),
  },
  setModeCommand: {
    optional: true,
    label: 'Последняя команда "set_active"',
    serializer: entityLikeSchema,
  },
  ipAddress: {
    optional: true,
    label: 'IP-адрес устройства',
    serializer: yup.string(),
  },
  openTime: {
    optional: true,
    label: 'Время открытия, сек',
    serializer: yup.number(),
  },
  openControlTime: {
    optional: true,
    label: 'Время контроля открытия, сек',
    serializer: yup.number(),
  },
  closeControlTime: {
    optional: true,
    label: 'Время контроля закрытия, сек',
    serializer: yup.number(),
  },
});
